import React from 'react';
import { Label } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { AvailableMedicalService } from '../../../../models/Entities/MedicalServices/AvailableMedicalService';

// own functions
import * as ownFunctions from './MedicalServiceSelectorFunctions';
import { connect } from 'react-redux';
import { Field, Option, Tag, TagPicker, TagPickerControl, TagPickerGroup, TagPickerInput, TagPickerList, TagPickerOption, TagPickerProps } from '@fluentui/react-components';

const MedicalServiceSelectorComponent = (
  props: ownFunctions.Props
) => {


  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [InternalSelected, setInternalSelected] = useState<AvailableMedicalService[] | undefined>();


  useEffect(() => {
    props.GetAllMedicalServices(1, 5000, undefined);
  }, [props.MedicalServices?.length === 0]);

  const [InternalMedicalServicesSelected, setInternalMedicalServicesSelected] =  useState<AvailableMedicalService[]>([]);

  useEffect(() => {
    if (props.MedicalServices?.length > 0 && props.MedicalServicesSelectedIds && props.MedicalServicesSelectedIds.length > 0) {
      setSelectedOptions(props.MedicalServices
        .filter((ms: AvailableMedicalService) => props.MedicalServicesSelectedIds?.includes(ms.id))
        .map((ms: AvailableMedicalService) => ms.serviceNameReference));
      setInternalMedicalServicesSelected(props.MedicalServices.filter((ms: AvailableMedicalService) => props.MedicalServicesSelectedIds?.includes(ms.id)));
    }

  }, [props.MedicalServices !== undefined && props.MedicalServices.length > 0, props.MedicalServicesSelectedIds !== undefined]);

  useEffect(() => {
    props.onSelectedServices(InternalMedicalServicesSelected);
  }, [InternalMedicalServicesSelected]);
  
  const onOptionSelect: TagPickerProps["onOptionSelect"] = (e, data) => {
    if (data.selectedOptions.length === 0) {
      setSelectedOptions([]);
      setInternalMedicalServicesSelected([]);
      props.onSelectedServices && props.onSelectedServices(undefined);
      return;
    }
    let InternalSelected: AvailableMedicalService[] = [];

    if (props.MultiselectEnable) {
      InternalSelected = props.MedicalServices?.filter((service: AvailableMedicalService) => data.selectedOptions.includes(service.serviceNameReference)) ?? [];
      setSelectedOptions(InternalSelected.map((service: AvailableMedicalService) => service.serviceNameReference));
      setInternalSelected(InternalSelected);
    } else {
      var InternalItemSelected = props.MedicalServices?.find((service: AvailableMedicalService) => service.serviceNameReference === data.value) as AvailableMedicalService;

      if(InternalItemSelected === undefined) {
        setSelectedOptions([]);
        setInternalSelected([]);
        props.onSelectedServices && props.onSelectedServices(undefined);
        return;
      }
      InternalSelected = [InternalItemSelected];
      setSelectedOptions(InternalSelected?.map((service: AvailableMedicalService) => service.serviceNameReference) ?? []);
      setInternalSelected(InternalSelected);
    }

    props.onSelectedServices && props.onSelectedServices(InternalSelected);
  };

  const tagPickerOptions = props.MedicalServices?.map((service: AvailableMedicalService) => service.serviceNameReference)?.filter(
    (service: string) => !selectedOptions?.includes(service)
  );

  return (
    <>
      <Field label="Seleccione una práctica médica" style={{ maxWidth: 400 }}>
        <TagPicker
          onOptionSelect={onOptionSelect}
          selectedOptions={selectedOptions}
        >
          <TagPickerControl>
            <TagPickerGroup aria-label="practicas seleccionadas">
              {selectedOptions?.map((option) => <Tag
                  key={option}
                  shape="rounded"
                >{option}</Tag>)}
            </TagPickerGroup>
            <TagPickerInput aria-label="Seleccione una practica médica" />
          </TagPickerControl>
          <TagPickerList>
            {tagPickerOptions?.length > 0 ? (
              tagPickerOptions?.map((option) => (
                <TagPickerOption
                  value={option}
                  key={option}
                >
                  {option}
                </TagPickerOption>
              ))
            ) : (
              <TagPickerOption value="no-options">
                No hay conceptos disponibles
              </TagPickerOption>
            )}
          </TagPickerList>
        </TagPicker>
        {props.noteText && <Label>{props.noteText}</Label>}
      </Field>

      {props.noteText && <small>{props.noteText}</small>}
    </>
  );
};

export default connect(
  ownFunctions.mapStateToProps,
  ownFunctions.mapDispatchToProps
)(MedicalServiceSelectorComponent as any);
